<template>
  <div class="template-module">
    <div
      class="template-module__background"
      :class="{
        'component-module-wrapper__module-contents--shape-mask': moduleData
          && moduleData.options && moduleData.options.shape
          && moduleData.options.shape !== 'default',
      }"
    />
    <AddModule
      v-if="mode === 'EDIT'"
      :module-id="id"
      :allow-drag="false"
      :canvas-name="canvasName"
      theme="placeholder"
      :module-to-replace="moduleData"
      :scale="scale"
      :disabled="isLocked(id)"
    />
  </div>
</template>

<script>
import { mapState } from 'pinia';
import AddModule from '@/components/AddModule.vue';
import {
  useEditorStore,
} from '@/stores';

export default {
  name: 'PlaceholderModule',
  components: {
    AddModule,
  },
  props: {
    canvasName: {
      type: String,
      required: true,
    },
    id: {
      type: String,
      required: true,
    },
    mode: {
      type: String,
      required: true,
    },
    moduleData: {
      type: Object,
      required: true,
    },
    scale: {
      type: Number,
      default: 1,
    },
  },
  computed: {
    ...mapState(useEditorStore, [
      'isLocked',
    ]),
  },
};
</script>

<style lang="stylus">
.template-module {
  align-items: center;
  break-inside: avoid; // Avoid splitting across pages when printing
  display: flex;
  height: 100%;
  justify-content: center;
  overflow: visible;

  &__background {
    bottom: 0;
    background-color: $comet-background-color-light;
    border-radius: 6px; // match module border radius
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
  }
}
</style>
